import React, { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../../components/ui/card';

interface CreateReferralLinkFormProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: ReferralLinkData) => void;
}

export interface ReferralLinkData {
  campaignName: string;
  landingPageUrl: string;
  utmSource: string;
  utmCampaign: string;
  referralCode: string;
}

const CreateReferralLinkForm = ({
  isOpen,
  onClose,
  onSubmit,
}: CreateReferralLinkFormProps) => {
  const [formData, setFormData] = useState<ReferralLinkData>({
    campaignName: '',
    landingPageUrl: '',
    utmSource: '',
    utmCampaign: '',
    referralCode: '',
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
    onClose();
  };

  const handleChange = (field: keyof ReferralLinkData, value: string) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <Card className="w-full max-w-md mx-4">
        <CardHeader>
          <CardTitle>Create Referral Link</CardTitle>
          <CardDescription>
            Generate a new referral link for your campaign
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label className="text-sm font-medium mb-2 block">
                Campaign Name
              </Label>
              <Input
                type="text"
                className="w-full h-10 rounded-md border bg-background px-3 text-sm"
                placeholder="Enter campaign name"
                value={formData.campaignName}
                onChange={e => handleChange('campaignName', e.target.value)}
              />
            </div>
            <div>
              <Label className="text-sm font-medium mb-2 block">
                Landing Page URL
              </Label>
              <Input
                type="text"
                className="w-full h-10 rounded-md border bg-background px-3 text-sm"
                placeholder="https://example.com"
                value={formData.landingPageUrl}
                onChange={e => handleChange('landingPageUrl', e.target.value)}
              />
            </div>
            <div>
              <Label className="text-sm font-medium mb-2 block">
                UTM Source
              </Label>
              <Input
                type="text"
                className="w-full h-10 rounded-md border bg-background px-3 text-sm"
                placeholder="e.g., google, facebook"
                value={formData.utmSource}
                onChange={e => handleChange('utmSource', e.target.value)}
              />
            </div>
            <div>
              <Label className="text-sm font-medium mb-2 block">
                UTM Campaign
              </Label>
              <Input
                type="text"
                className="w-full h-10 rounded-md border bg-background px-3 text-sm"
                placeholder="e.g., spring_promo"
                value={formData.utmCampaign}
                onChange={e => handleChange('utmCampaign', e.target.value)}
              />
            </div>
            <div>
              <Label className="text-sm font-medium mb-2 block">
                Referral Code
              </Label>
              <Input
                type="text"
                className="w-full h-10 rounded-md border bg-background px-3 text-sm"
                placeholder="Your referral code"
                value={formData.referralCode}
                onChange={e => handleChange('referralCode', e.target.value)}
              />
            </div>
            <div className="flex gap-2 pt-4">
              <Button
                variant="outline"
                type="button"
                className="flex-1"
                onClick={onClose}
              >
                Cancel
              </Button>
              <Button type="submit" className="flex-1">
                Generate Link
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default CreateReferralLinkForm;
